<template>
  <div class="portfolio" style="min-height:100vh" >
    <div style="background-color: #000000ad !important; min-height:100vh;">
      <br />
      <a-row>
      <a-col :xs="24" :sm="24" :md="24" :lg="24">
        <div class="text-h1 text-white text-center">
          应用案例
          <br />
          <span class="text-center text-grey text-h6"></span>
        </div>
      </a-col>
    </a-row>
      <br />
      <a-row  class="text-center" style="padding-bottom: 99px;max-width: 1020px;margin: 0 auto">
        <a-rol
          v-for="index in 5"
          :key="index"
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
          :action="$t('home.portfolio.case1.loc')"
        >
          <div style="line-height: 0">
            <span>
              <div class="flip-card">
                <div class="flip-card-inner">
                  <div class="flip-card-front">
                    <img
                      :src="'/statics/images/case' + index+'.png'"
                      width="340"
                      height="263"
                      object-fit="cover"
                    />
                  </div>
                  <div class="flip-card-back">
                    <div style="height: 100%; line-height: 100%">
                      <div
                        class="text-h1"
                        style="
                          color:black;
                          width: 200px;
                          line-height:200%;
                          background-color:rgba(255,255,255,0.5);
                          position: absolute;
                          top: 20%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                        "
                      >
                        {{ $t('home.portfolio.case'+index+'.loc') }}
                      </div>
                      <div
                        style="
                          min-width:250px;
                          font-size:16px;
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, 0);
                        "
                      >
                        {{ $t('home.portfolio.case'+index+'.desc') }}
                      </div>
                      <div
                        style="
                          position: absolute;
                          top: 80%;
                          left: 50%;
                          transform: translate(-50%, 0);
                          background-color: transparent;
                        "
                      >
                        <a-button
                          v-if="links[index-1]"
                          shape="round"
                          primary
                          :href="links[index-1]"
                          >详情</a-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br v-if="index == 3" />
            </span>
          </div>
        </a-rol>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Portfolio",
  data() {
    return {
      theme_color: "rgb(123,170,74)",
      links: [
        "cases#wind",
        "cases#starter",
       
        "",
        "cases#ups",
        "cases#industrial",
        ""

      ],
      
    };
  },
};
</script>

<style scoped>
.portfolio {
  background: url(/statics/images/portfolio.png);
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
}

.flip-card {
  background-color: transparent;
  width: 340px;
  height: 263px;
  overflow: hidden;
}

/* This container is needed to position the front and back side */
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}


/* Position the front and back side */
.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
}

/* Style the front side (fallback if image is missing) */
.flip-card-front {
  transition: 0.3s;
}

/* Style the back side */
.flip-card-back {
  background-color: rgba(123, 170, 74, 0.5);
  color: white;
  opacity: 0;
  transition: 0.3s;
}

.flip-card:hover .flip-card-back {
  opacity: 1;
}
.flip-card:hover .flip-card-front {
  transform: scale(1.1);
}
</style>
